import React from 'react';
import { List, useTable, EditButton, DeleteButton, CreateButton } from '@refinedev/antd';
import { Table, Tag, Space, Image } from 'antd';

export interface PetSkinRow {
  id: string;
  slug: string;
  name: string;
  imageUrl: string;
  imageUrlResolved: string;
  heroImageUrl: string | null;
  heroImageUrlResolved: string | null;
  poseImageUrls: string[];
  poseImageUrlsResolved: string[];
  priceCoins: number;
  unlockLevel: number | null;
  sortOrder: number;
  isActive: boolean;
}

/** The pet hat skins sold in the app's Store tab. */
export const PetSkinList: React.FC = () => {
  const { tableProps } = useTable<PetSkinRow>({
    resource: 'pet-skins',
    pagination: { current: 1, pageSize: 20 },
    queryOptions: { keepPreviousData: true },
  });

  return (
    <List title="Pet Skins" headerButtons={<CreateButton />}>
      <Table {...tableProps} rowKey="id" scroll={{ x: 1000 }}>
        <Table.Column
          title="Artwork"
          dataIndex="imageUrlResolved"
          width={90}
          render={(url: string) => (
            <Image src={url} width={56} height={56} style={{ objectFit: 'contain' }} />
          )}
        />
        <Table.Column title="Name" dataIndex="name" width={180} />
        <Table.Column
          title="Slug"
          dataIndex="slug"
          width={160}
          render={(slug: string) => <code>{slug}</code>}
        />
        <Table.Column title="Price (coins)" dataIndex="priceCoins" width={120} />
        <Table.Column
          title="Unlock level"
          dataIndex="unlockLevel"
          width={120}
          render={(v: number | null) => v ?? '—'}
        />
        <Table.Column
          title="Poses"
          dataIndex="poseImageUrls"
          width={80}
          render={(v: string[]) => v?.length ?? 0}
        />
        <Table.Column title="Sort" dataIndex="sortOrder" width={70} />
        <Table.Column
          title="Active"
          dataIndex="isActive"
          width={90}
          render={(v: boolean) => <Tag color={v ? 'green' : 'default'}>{v ? 'Yes' : 'No'}</Tag>}
        />
        <Table.Column
          title="Actions"
          width={110}
          render={(_: unknown, row: PetSkinRow) => (
            <Space>
              <EditButton hideText size="small" recordItemId={row.id} />
              <DeleteButton hideText size="small" recordItemId={row.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
